module.exports = __webpack_public_path__ + "img/circle-messenger2.a001bce8.png";